require('./bootstrap');

import Vue from 'vue/dist/vue';
import VueAxios from 'vue-axios';
import axios from 'axios';

window.Vue = require('vue');
window.events = new Vue();
window.flash = function(message,type) {
    window.events.$emit('flash',message, type);
}

Vue.component('downloader-component', require('./components/DownloaderComponent.vue').default);
Vue.component('downloads-component', require('./components/DownloadsComponent.vue').default);
Vue.component('files-component', require('./components/FilesComponent.vue').default);
Vue.component('file-component', require('./components/FileComponent.vue').default);
Vue.component('account-settings-component', require('./components/AccountSetttingsComponent.vue').default);
Vue.component('flash', require('./components/FlashComponent.vue').default);

Vue.use(VueAxios, axios);


const app = new Vue({
    el: '#rpnet',
});